module.exports = __webpack_public_path__ + "static/media/2020winner-jessica.fcf10cbc.jpg";